import { useNavigate } from 'react-router-dom';
import { DropdownMenuItem } from '@c2fo/liquidity';
import { EyeIcon, PencilIcon } from '@c2fo/liquidity/icons';
import { CredentialTypeChip } from '../CredentialTypeChip';
import { useCredentialsState } from '../../contexts';
import type { CredentialsSortField } from '../../contexts/FileDeliveryContext';
import { TableHeader } from '../TableHeader';
import { DataTable, DataTableHead, DataTableBody, DataTableRow, DataTableCell } from '../DataTable';
import { ActionsMenu } from '../ActionsMenu';
import { formatDateWithTimezone } from '../../../../utils/dateFormat';

export const CredentialTable: React.FC = () => {
  const navigate = useNavigate();
  const { credentials, sortField, sortDirection, setSort } = useCredentialsState();

  const handleSort = (field: CredentialsSortField) => {
    if (sortField === field) {
      const newDirection = sortDirection === 'asc' ? 'desc' : 'asc';
      setSort(field, newDirection);
    } else {
      setSort(field, 'asc');
    }
  };

  return (
    <DataTable>
      <DataTableHead>
        <TableHeader
          field="display_name"
          label="Name"
          currentSortField={sortField}
          currentSortDirection={sortDirection}
          onSort={handleSort}
        />
        <TableHeader
          field="credential_type"
          label="Type"
          currentSortField={sortField}
          currentSortDirection={sortDirection}
          onSort={handleSort}
          align="center"
          className="w-24"
        />
        <TableHeader
          field="create_time"
          label="Created"
          currentSortField={sortField}
          currentSortDirection={sortDirection}
          onSort={handleSort}
          className="w-40"
        />
        <TableHeader
          field="update_time"
          label="Updated"
          currentSortField={sortField}
          currentSortDirection={sortDirection}
          onSort={handleSort}
          className="w-40"
        />
        <TableHeader label="" className="w-16" />
      </DataTableHead>
      <DataTableBody>
        {credentials.map((credential) => (
          <DataTableRow key={credential.uid}>
            <DataTableCell variant="primary">{credential.displayName}</DataTableCell>
            <DataTableCell align="center">
              <CredentialTypeChip credentialType={credential.credentialType} />
            </DataTableCell>
            <DataTableCell variant="date">
              {credential.createTime ? formatDateWithTimezone(credential.createTime) : '-'}
            </DataTableCell>
            <DataTableCell variant="date">
              {credential.updateTime ? formatDateWithTimezone(credential.updateTime) : '-'}
            </DataTableCell>
            <DataTableCell align="center">
              <ActionsMenu>
                <DropdownMenuItem
                  className="active:bg-lightBlue-100"
                  onSelect={() => navigate(`/file-delivery/credentials/${credential.uid}`)}
                >
                  <EyeIcon className="h-4 w-4 mr-2" />
                  View Details
                </DropdownMenuItem>
                <DropdownMenuItem
                  className="active:bg-lightBlue-100"
                  onSelect={() => navigate(`/file-delivery/credentials/${credential.uid}/edit`)}
                >
                  <PencilIcon className="h-4 w-4 mr-2" />
                  Edit
                </DropdownMenuItem>
              </ActionsMenu>
            </DataTableCell>
          </DataTableRow>
        ))}
      </DataTableBody>
    </DataTable>
  );
};
